import currencyReducer from "./currencyReducer";
import productReducer from "./productReducer";
import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";
import compareReducer from "./compareReducer";
import { combineReducers } from "redux";
import { createMultilanguageReducer } from "redux-multilanguage";
import SessionReducer from "./sessionReducer";
import ErrorsReducer from "./errorsReducer";
import entitiesReducer from "./entitiesReducer";
import navReducer from "./navReducer";
import SettingsReducer from "./settingsReducer";

const rootReducer = combineReducers({
  multilanguage: createMultilanguageReducer({ currentLanguageCode: "en" }),
  currencyData: currencyReducer,
  productData: productReducer,
  cartData: cartReducer,
  wishlistData: wishlistReducer,
  compareData: compareReducer,
  session: SessionReducer,
  errors: ErrorsReducer,
  entities: entitiesReducer,
  navMenu: navReducer,
  settings: SettingsReducer
});

export default rootReducer;
